'use client';

import { useLocale } from './LocaleProvider';
import { dict, t } from '@/lib/i18n';

export function TrustStrip() {
  const { locale } = useLocale();

  return (
    <section className="relative border-y border-white/5 bg-ink-800/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 py-12">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8">
          <div className="lg:max-w-md">
            <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-red-400/90 font-semibold mb-2">
              <span className="w-1 h-1 rounded-full bg-red-400 animate-pulse" />
              {t(dict.trust.badge, locale)}
            </div>
            <h2 className="font-serif text-2xl sm:text-3xl text-fog-100 leading-snug">
              {t(dict.trust.title, locale)}
            </h2>
          </div>
          <div className="flex-1 grid sm:grid-cols-3 gap-4">
            {dict.trust.items.map((item, i) => (
              <div
                key={i}
                className="group rounded-luxe bg-white/[0.02] border border-white/5 px-4 py-4 text-sm text-fog-300 flex items-center gap-3 transition-[border-color,background-color,color] duration-300 ease-out hover:border-gold/20 hover:bg-white/[0.04] hover:text-fog-100"
              >
                <span
                  aria-hidden
                  className="text-gold-soft text-lg leading-none transition-transform duration-300 ease-out group-hover:scale-110"
                >
                  ✓
                </span>
                <span>{t(item, locale)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
